var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0618 0.75H22.9594V4.95499H25.0618V0.75Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0618 36.6396H22.9594V28.7131H25.0618V36.6396ZM25.0618 20.8077H22.9594V12.8813H25.0618V20.8077Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0618 44.5449H22.9594V48.7499H25.0618V44.5449Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0009 23.709H43.7959V25.8115H48.0009V23.709Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8894 25.8115H27.963V23.709H35.8894V25.8115ZM20.0576 25.8115H12.1312V23.709H20.0576V25.8115Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20499 23.709H0V25.8115H4.20499V23.709Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPlus);
export default __webpack_public_path__ + "static/media/SYMBOL_PLUS.685d24fe20e4b17d23b1aa0144357227.svg";
export { ForwardRef as ReactComponent };